module.exports = __webpack_public_path__ + "img/icon-reflash.71ea39a0.png";